  <breadcrumb
   [paginas]="[{route:'/home',name:'Home'},{route:'/registra-check-out',name:'Registrar Check-Out'}]">
</breadcrumb>
  <!-- Filtro -->
   <app-filtro-padrao [template]="2" (filtroEmitter)="listeningFiltroEmitter($event)"></app-filtro-padrao>
